module.exports = __webpack_public_path__ + "img/crystalheart_i.c6002a31.jpg";